import Cookies from 'js-cookie';
const url = 'sea-soft-test';
const key = 'Admin-Token' + url;

export function getToken() {
  return Cookies.get(key);
}

export function setToken(token) {
  return Cookies.set(key, token);
}

export function removeToken() {
  return Cookies.remove(key);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js